function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Menu"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_5_",
  d: "M0 42.5h283.5v28.3H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_4_",
  d: "M0 127.6h283.5v28.3H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3_",
  d: "M0 212.6h283.5v28.3H0z"
}))));